





























import { Component, Vue, Prop } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { Actions } from '@/util/vuex-types'
import Event from '@/models/event'
import moment from 'moment'
import axios from '@/server-axios'

@Component
export default class CreateBrewery extends Vue {
    breweryName: string = ''
    submitting: boolean = false
    successfullyCreated = false
    error = false
    @Action [Actions.FETCH_BREWERIES]: any

    async createBrewery() {
        try {
            this.successfullyCreated = false
            this.submitting = true
            this.error = false
            const request = {
               name: this.breweryName,
               visited: false,
            }
            const { status } = await axios.post('breweries/', request, {
                headers: {
                    Authorization: 'Bearer ' + await this.$auth.getAccessToken(),
                },
            })

            if (status === 201) {
                this.successfullyCreated = true
                this.submitting = false
                this.fetchBreweries()
            } else if (status >= 400) {
                this.error = true
                this.submitting = false
            }
        } catch (e) {
            console.warn(e)
        }
    }
}
